import(/* webpackMode: "eager", webpackExports: ["ServicesProvider"] */ "/vercel/path0/src/contexts/ServicesContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/index.css");
